import styled from 'styled-components';

import { colors } from 'global/colors';
import { Link as BaseLink } from '../../components';

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;

export const Link = styled(BaseLink)`
  font-size: 14px;
  color: ${colors.darkBlue};

  :hover {
    color: ${colors.green};
  }
`;

export const SignupDescription = styled.p`
  color: #555555;
  font-size: 14px;
  margin-top: 10px;
  width: 50%;
  text-align: center;

  @media (max-width: 667px) {
    width: 100%;
  }
`;
